// @flow

import React, { type Node } from 'react';
import { Label } from '../../atom/label';
import ebanxLogo from './ebanx.svg';

export function Footer(): Node {
  return (
    <div style={{
      backgroundColor: '#fefefe',
      borderTop: '1px solid #e6e6e6',
      marginTop: '1em',
      padding: '1em',
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    }}>
      <div>
        <Label as="span">Pagamento seguro via </Label>
        <img style={{ height: '14px' }} alt="EBANX" src={ebanxLogo} />
      </div>
      <div style={{
        boxSizing: 'border-box',
        height: '1px',
        width: '50%',
        margin: '0.5em auto',
        backgroundColor: '#d8d8d8',
      }}></div>
      <div><Label>Parceiro oficial da Uber</Label></div>
    </div>
  );
}
